import React from 'react';
import {FaHeart, FaFacebook, FaInstagram, FaThreads} from 'react-icons/fa6';

const Footer = () => {
  return (
    <footer className="w-full py-6 px-4 bg-white/80 backdrop-blur-sm border-t border-pink-200">
      <div className="max-w-6xl mx-auto">
        {/* Social Media Links */}
        <div className="flex items-center justify-center gap-4 mb-4">
          <a
            href="https://www.facebook.com/profile.php?id=61578745554661"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-md hover:shadow-lg"
            aria-label="Visit our Facebook page"
          >
            <FaFacebook size={20} />
          </a>
          <a
            href="https://www.instagram.com/homy.hk"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-md hover:shadow-lg"
            aria-label="Visit our Instagram page"
          >
            <FaInstagram size={20} />
          </a>
          <a
            href="https://www.threads.com/@homy.hk"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-800 to-black text-white flex items-center justify-center hover:scale-110 transition-transform shadow-md hover:shadow-lg"
            aria-label="Visit our Threads page"
          >
            <FaThreads size={20} />
          </a>
        </div>

        {/* Copyright */}
        <div className="flex items-center justify-center gap-2">
          <span className="text-sm text-gray-700">Made with</span>
          <FaHeart className="text-pink-500 animate-pulse" size={16} />
          <span className="text-sm text-gray-700">by</span>
          <a
            href="https://homy.hk"
            target="_blank"
            rel="noopener noreferrer"
            className="text-pink-600 font-bold hover:text-pink-700 transition-colors hover:underline"
          >
            Homy Tech Limited
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;